import constants from '@pages/Deals/constants';
import type { DealsLandingState } from '@typings/deals';

/**
 * Initial state for the deals landing page Redux store
 *
 * Sets up default values for all filters and state properties:
 * - All filters start unselected (null values)
 * - Location defaults to the application's default location
 * - Loading and error states start as false/null
 * - Categories start as null until first fetch
 */
export const initialState: DealsLandingState = {
	filters: {
		dealType: null,
		location: constants.DEFAULT_LOCATION,
		categoryCode: null,
	},
	loading: false,
	error: null,
	categories: null,
};
